<template>
  <div>
    <b-modal
      ref="modal-setting-client"
      :title="$t(getTitleModal)"
      modal-class="modal-primary"
      @hidden="$emit('hideModal')"
      size="xmd"
      scrollable
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="scroll-kanban">
        <ValidationObserver ref="ref-validation-client">
          <b-row>
            <b-col lg="4">
              <b-row class="">
                <!-- File -->
                <b-col md="10" xl="10" class="mx-auto">
                  <b-form-group label="" label-for="bill_number" class="m-0">
                    <div
                      class="form-group m-0"
                      :class="requiredImg ? 'border-danger' : 'border-black'"
                      style="border-radius: 10px; padding: 10px"
                    >
                      <div class="image-upload">
                        <input
                          id="file_input_1"
                          type="file"
                          hidden
                          @change="getImage"
                        />
                        <!-- :disabled="
                                isView || validationMode || isMigration
                              " -->
                        <!-- INPUT_FILE FIN -->
                        <div class="form-group m-0" style="cursor: pointer">
                          <iframe
                            v-if="isPdf"
                            :src="viewImage"
                            frameborder="0"
                            width="100%"
                            height="100%"
                            :style="'height: 300px'"
                          />
                          <figure v-else class="m-0" @click="inputImage()">
                            <img
                              class="bg-light"
                              :src="viewImage"
                              width="100%"
                              height="100%"
                            />
                          </figure>
                        </div>
                      </div>
                    </div>
                  </b-form-group>
                  <div class="mt-1 d-flex justify-content-center">
                    <div v-if="autoGeneratedFileNameIsCompleted">
                      <b-form-group>
                        <b-form-input
                          v-model="fileGeneratedName"
                          class="text-center"
                        />
                      </b-form-group>
                    </div>
                    <div class="text-center ml-1">
                      <b-button variant="outline-info" @click="inputImage()">
                        <feather-icon icon="UploadIcon" size="15" />
                      </b-button>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-col>

            <!-- Areas -->
            <b-col lg="8">
              <b-row class="border-left">
                <!-- Document Types -->
                <b-col xl="6" lg="12" md="12" sm="12">
                  <ValidationProvider
                    v-slot="{ errors }"
                    rules="required"
                    name="document_type_id"
                  >
                    <b-form-group
                      :label="$t('Document Type')"
                      label-for="document_type_id"
                      :state="errors[0] ? false : null"
                    >
                      <b-skeleton v-if="!finishedLoading" type="input" />
                      <v-select
                        v-if="finishedLoading"
                        id="document_type_id"
                        v-model="form.document_type_id"
                        :options="documentTypes"
                        label="name"
                        :reduce="(dt) => dt.id"
                        @input="changeDocumentType"
                      />
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <!-- Document Number -->
                <b-col xl="6" lg="12" md="12">
                  <ValidationProvider
                    v-slot="{ errors, valid }"
                    name="NumberDoc"
                    rules="required"
                  >
                    <b-form-group
                      :label="$t('Doc Number')"
                      label-for="number-doc"
                    >
                      <b-skeleton v-if="!finishedLoading" type="input" />
                      <b-form-input
                        v-if="finishedLoading"
                        id="number-doc"
                        v-model="form.document_number"
                        trim
                        :state="errors[0] ? false : valid ? true : null"
                        :disabled="!docTypeSelected"
                      />
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <!-- Business Name -->
                <b-col lg="12">
                  <ValidationProvider
                    v-slot="{ errors, valid }"
                    name="business_name"
                    rules="required"
                  >
                    <b-form-group
                      :label="$t('Business Name')"
                      label-for="business_name"
                    >
                      <b-skeleton v-if="!finishedLoading" type="input" />
                      <b-form-input
                        v-if="finishedLoading"
                        id="business_name"
                        v-model="form.business_name"
                        name="business_name"
                        autofocus
                        :disabled="!docTypeSelected"
                        :state="errors[0] ? false : valid ? true : null"
                        trim
                      />
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <!-- Ubigeous  -->
                <b-col xl="6" lg="12" md="12" sm="12">
                  <ValidationProvider v-slot="{ errors }" name="ubigeous_id">
                    <b-form-group
                      :label="$t('Ubigeous')"
                      label-for="ubigeous_id"
                      :state="errors[0] ? false : null"
                    >
                      <b-skeleton v-if="!finishedLoading" type="input" />
                      <b-form-input
                        v-if="finishedLoading"
                        id="ubigeous_id"
                        v-model="form.ubigeous_id"
                        name="ubigeous_id"
                        autofocus
                        :state="errors[0] ? false : null"
                        trim
                      />
                      <!-- <v-select
                        v-if="finishedLoading"
                        id="ubigeous_id"
                        v-model="form.ubigeous_id"
                        :options="ubigeous"
                        placeholder="Search..."
                        label="name"
                        @input="selectHandler"
                        @search="searchItems"
                      /> -->
                      <!-- <v-select
                        v-if="finishedLoading"
                        id="ubigeous_id"
                        v-model="form.ubigeous_id"
                        :options="documentTypes"
                        label="name"
                        :reduce="(dt) => dt.id"
                      /> -->
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <!-- Address -->
                <b-col lg="12">
                  <ValidationProvider
                    v-slot="{ errors, valid }"
                    name="address"
                    rules="required"
                  >
                    <b-form-group :label="$t('Address')" label-for="address">
                      <b-skeleton v-if="!finishedLoading" type="input" />
                      <b-form-input
                        v-if="finishedLoading"
                        id="address"
                        v-model="form.address"
                        name="address"
                        autofocus
                        :state="errors[0] ? false : valid ? true : null"
                        trim
                      />
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <!-- Phone -->
                <b-col lg="4" md="12">
                  <ValidationProvider
                    v-slot="{ errors, valid }"
                    name="phone"
                    rules="required"
                  >
                    <b-form-group :label="$t('Phone')" label-for="phone">
                      <b-skeleton v-if="!finishedLoading" type="input" />
                      <b-form-input
                        v-if="finishedLoading"
                        id="phone"
                        v-model="form.phone"
                        name="phone"
                        autofocus
                        :state="errors[0] ? false : valid ? true : null"
                        trim
                      />
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <!-- Cell Phone -->
                <b-col lg="4" md="12">
                  <ValidationProvider
                    v-slot="{ errors, valid }"
                    name="cell_phone"
                    rules="required"
                  >
                    <b-form-group
                      :label="$t('Cell Phone')"
                      label-for="cell_phone"
                    >
                      <b-skeleton v-if="!finishedLoading" type="input" />
                      <b-form-input
                        v-if="finishedLoading"
                        id="cell_phone"
                        v-model="form.cell_phone"
                        name="cell_phone"
                        autofocus
                        :state="errors[0] ? false : valid ? true : null"
                        trim
                      />
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <!-- Delegate -->
                <b-col lg="4" md="12">
                  <ValidationProvider
                    v-slot="{ errors, valid }"
                    name="delegate"
                    rules="required"
                  >
                    <b-form-group :label="$t('Delegate')" label-for="delegate">
                      <b-skeleton v-if="!finishedLoading" type="input" />
                      <b-form-input
                        v-if="finishedLoading"
                        id="delegate"
                        v-model="form.delegate"
                        name="delegate"
                        autofocus
                        :state="errors[0] ? false : valid ? true : null"
                        trim
                      />
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <!-- Email -->
                <b-col lg="12" md="12">
                  <ValidationProvider
                    v-slot="{ errors, valid }"
                    name="email"
                    rules="required"
                  >
                    <b-form-group :label="$t('Email')" label-for="email">
                      <b-skeleton v-if="!finishedLoading" type="input" />
                      <b-form-input
                        v-if="finishedLoading"
                        id="email"
                        v-model="form.email"
                        name="email"
                        autofocus
                        :state="errors[0] ? false : valid ? true : null"
                        trim
                      />
                    </b-form-group>
                  </ValidationProvider>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </ValidationObserver>
      </div>

      <template #modal-footer>
        <div class="d-flex justify-content-end">
          <b-button
            v-if="clientId == null"
            @click="registerClient"
            variant="outline-success"
            >{{ $t("REGISTER") }}</b-button
          >
          <b-button
            v-if="clientId != null"
            @click="updateClient"
            variant="outline-warning"
            >{{ $t("UPDATE") }}</b-button
          >
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import modalMixin from "@/mixins/modal";
import ClientsService from "@/views/commons/clients/services/clients.service.js";
import axios from "axios";

export default {
  mixins: [modalMixin],
  props: {
    clientId: {
      default: null,
    },
  },
  data() {
    return {
      documentTypes: [],
      fileGeneratedName: "",
      form: {
        document_type_id: null,
        document_number: null,
        business_name: null,
        ubigeous_id: null,
        address: null,
        phone: null,
        cell_phone: null,
        delegate: null,
        images: null,
      },
      showInMaxSize: false,
      isPdf: false,
      requiredImg: false,
      viewImage: "/assets/images/upload_file.png",
      finishedLoading: false,
      docTypeSelected: false,
      ubigeous: [],
    };
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    getTitleModal() {
      if (this.clientId == null) return "NEW CLIENT";
      return "EDIT CLIENT";
    },
    getCurrentDateInFormat() {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = currentDate.getMonth() + 1;
      const day = currentDate.getDate();
      const formattedDate = `${month}${day}${year}`;

      return formattedDate;
    },
    autoGeneratedFileNameIsCompleted() {
      return (
        this.currentFileTypeName !== "" &&
        this.leadId !== "" &&
        this.getCurrentDateInFormat !== ""
      );
    },
    currentFileTypeName() {
      // const currentFileType = this.fileTypes.find(
      //   ({ file_type_id }) => file_type_id === this.currentFileTypeId
      // );
      // return currentFileType?.file_type_name
      //   ? currentFileType.file_type_name
      //   : "";
      return "file-fileee";
    },
    fileAutoGeneratedName() {
      const fileAutoGeneratedName = `${this.currentFileTypeNameInitials} ${this.getCurrentDateInFormat} ${this.leadId}`;
      return fileAutoGeneratedName;
    },
  },
  watch: {
    "form.document_number": function (value) {
      this.disableInput = false;
      if (value == null) return;
      if (this.form.document_type_id == 1 && value.length == 8) {
        this.searchData(value);
      } else if (this.form.document_type_id == 2 && value.length == 11) {
        this.searchData(value);
      }
    },
  },
  mounted() {
    this.toggleModal("modal-setting-client");
  },
  async created() {
    try {
      this.finishedLoading = false;
      this.addPreloader();
      console.log("created...");
      await Promise.all([this.getDocumentTypes(), this.getDataClientById()]);
    } catch (error) {
      this.showToastError(error?.response?.data?.message);
    } finally {
      this.finishedLoading = true;
      this.removePreloader();
    }
  },
  methods: {
    selectHandler(key) {
      console.log("key: ", key);
    },
    searchItems: _.debounce(async function (search) {
      if (search.length < 1 || search == undefined) return;
      const { data } = await BillsService.searchItemsLogistic({ text: search });
      this.filteredOptions = data;
    }),
    async getDataClientById() {
      if (this.clientId == null) return;
      try {
        const { data } = await ClientsService.getDataClientById({
          client_id: this.clientId,
        });
        this.form.document_type_id = data[0].document_type_id;
        this.form.document_number = data[0].document_number;
        this.form.business_name = data[0].business_name;
        this.form.ubigeous_id = data[0].ubigeous_id;
        this.form.address = data[0].address;
        this.form.phone = data[0].phone;
        this.form.cell_phone = data[0].cell_phone;
        this.form.delegate = data[0].delegate;
        this.form.email = data[0].email;
        this.viewImage = data[0].path ? data[0].path : this.viewImage;
        this.docTypeSelected = true;
      } catch (error) {
        throw error;
      }
    },

    async getDocumentTypes() {
      try {
        const { data } = await ClientsService.getDocumentTypes({});
        this.documentTypes = data;
      } catch (error) {
        throw error;
      }
    },

    changeDocumentType(val) {
        this.form.document_number = null;
        this.form.business_name = null;
        this.form.business_name = null;

      this.docTypeSelected = false;
      if (val != null) {
        this.docTypeSelected = true;
        return;
      }
    },

    async registerClient() {
      const result = await this.$refs["ref-validation-client"].validate();
      if (!result) return;

      const confirm = await this.showConfirmSwal();
      if (!confirm.isConfirmed) return;
  
      try {
        this.addPreloader();
        // const params = {
        //   document_type_id: this.form.document_type_id,
        //   document_number: this.form.document_number,
        //   business_name: this.form.business_name,
        //   ubigeous_id: this.form.ubigeous_id,
        //   address: this.form.address,
        //   phone: this.form.phone,
        //   cell_phone: this.form.cell_phone,
        //   delegate: this.form.delegate,
        //   image: this.form.images,
        //   email: this.form.email,
        // };
        const formData = new FormData();
        formData.append("document_type_id", this.form.document_type_id);
        formData.append("document_number", this.form.document_number);
        formData.append("business_name", this.form.business_name);
        formData.append("ubigeous_id", this.form.ubigeous_id);
        formData.append("address", this.form.address);
        formData.append("phone", this.form.phone);
        formData.append("cell_phone", this.form.cell_phone);
        formData.append("delegate", this.form.delegate);
        formData.append("image", this.form.images);
        formData.append("email", this.form.email);
        const { data } = await ClientsService.registerClient(formData);
        if (data.type == "warning") {
          this.showToastWarning(data.message);
          return;
        }
        if (data.type == "success") this.showToastSuccess(data.message);
        this.$emit("registered");
      } catch (error) {
        console.log(error);
        this.showToastError(error?.response?.data?.message);
      } finally {
        this.removePreloader();
      }
    },

    async updateClient() {
      const result = await this.$refs["ref-validation-client"].validate();
      if (!result) return;

      const confirm = await this.showConfirmSwal();
      if (!confirm.isConfirmed) return;
  
      try {
        this.addPreloader();
        const params = {
          client_id: this.clientId,
          document_type_id: this.form.document_type_id,
          document_number: this.form.document_number,
          business_name: this.form.business_name,
          ubigeous_id: this.form.ubigeous_id,
          address: this.form.address,
          phone: this.form.phone,
          cell_phone: this.form.cell_phone,
          delegate: this.form.delegate,
          image: this.form.images,
          email: this.form.email,
        };
        
        const { data } = await ClientsService.updateClient(params);
        if (data.type == "warning") {
          this.showToastWarning(data.message);
          return;
        }
        if (data.type == "success") this.showToastSuccess(data.message);
        this.$emit("registered");
      } catch (error) {
        console.log(error);
        this.showToastError(error?.response?.data?.message);
      } finally {
        this.removePreloader();
      }
    },

    inputImage() {
      document.getElementById("file_input_1").click();
    },

    getImage(e) {
      this.requiredImg = false;
      if (!e.target.files.length) {
        this.requiredImg = true;
        this.form.images = null;
        this.form.fileName = "";
        this.viewImage = "/assets/images/upload_file.png";
        return;
      }
      const file = e.target.files[0];
      const fileName = file.name;

      if (this.isMigration) {
        this.form.fileSize = this.modalData.size;
        this.form.fileName = this.modalData.file_name;
      } else {
        this.form.fileSize = file.size;
        this.form.fileName = fileName;
      }

      console.log("file: ", file);
      this.form.images = file;
      console.log("form.images: ", this.form.images);
      this.form.extension = fileName.split(".").pop(); //--
      if (["pdf", "jpg", "png", "jpeg"].includes(this.form.extension)) {
        this.showButtonDetail = true;
        if (this.form.extension === "pdf") {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          // eslint-disable-next-line no-return-assign
          reader.onload = () => (this.viewImage = reader.result);
          this.isPdf = true;
        } else {
          this.isPdf = false;
        }
      } else {
        this.showButtonDetail = false;
        this.showInMaxSize = false;
        this.isPdf = false;
      }
      if (this.existViewForFile(this.form.extension)) return;
      this.uploadImage(file);
    },

    uploadImage(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.viewImage = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    async searchData(value) {
      this.addPreloader();
      // let type = this.userData.document_type == 1 ? 'dni' : 'ruc';
      // console.log(process.env.APIS_PERU_URL)
      // const url = `${process.env.APIS_PERU_URL}/${type}/${value}?token=${process.env.APIS_PERU_TOKEN}`;
      // console.log(url)

      const getForDni = `https://dniruc.apisperu.com/api/v1/dni/${value}?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJlbWFpbCI6ImJvZ3VpcnJlQGdtYWlsLmNvbSJ9.oAtXJNjZbJr6In7Lou-8mN4996MRachznGrhc6qCQwc`;
      const getForRuc = `https://dniruc.apisperu.com/api/v1/ruc/${value}?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJlbWFpbCI6ImJvZ3VpcnJlQGdtYWlsLmNvbSJ9.oAtXJNjZbJr6In7Lou-8mN4996MRachznGrhc6qCQwc`;
      let url = null;
      if (this.form.document_type_id == 1) {
        url = getForDni;
      } else if (this.form.document_type_id == 2) {
        url = getForRuc;
      }
      try {
        const { data } = await axios.get(url);
        if (data.success) {
          this.disableInput = true;
          this.form.business_name = `${data.nombres} ${data.apellidoPaterno} ${data.apellidoMaterno}`;
        } else {
          this.showToastError("Los datos no fueron encontrados");
        }
        // this.removePreloader();
      } catch (error) {
        console.log(error);
        this.showToastError(error?.response?.data);
        // this.removePreloader();
      } finally {
        this.removePreloader();
      }
    },

    existViewForFile(extension) {
      if (extension === "pdf") {
        this.viewImage = "/assets/images/drag-drop/ext_files/pdf.png";
        return true;
      }
      if (["xls", "xlsx", "xlsm", "xlsb", "csv"].includes(extension)) {
        this.viewImage = "/assets/images/drag-drop/ext_files/excel.png";
        return true;
      }
      if (["doc", "docx"].includes(extension)) {
        this.viewImage = "/assets/images/drag-drop/ext_files/doc.png";
        return true;
      }
      if (!["jpg", "png", "jpeg"].includes(extension)) {
        this.viewImage = "/assets/images/extensions/archivodesc.png";
        return true;
      }
      return false;
    },
  },
};
</script>

<style>
</style>